<div class="flex flex-col">
  <div class="px-6 pt-4 pb-2">
    <div class="flex justify-between items-center">
      <div>
        <h1 class="text-2xl font-bold text-gray-800">Comandas</h1>
        <p class="text-sm text-gray-500">Listagem de comandas do restaurante</p>
      </div>
    </div>
  </div>

  <div class="px-6 py-4 bg-white shadow shrink-0 z-10">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-1">Status</label>
        <p-dropdown
          [options]="statusOptions"
          [(ngModel)]="statusFilter"
          (onChange)="applyFilters()"
          optionLabel="label"
          optionValue="value"
          placeholder="Todos"
          class="w-full text-sm"
        ></p-dropdown>
      </div>
      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-1">Mesa</label>
        <p-dropdown
          [options]="mesaOptions"
          [(ngModel)]="mesaIdFilter"
          (onChange)="applyFilters()"
          optionLabel="label"
          optionValue="value"
          placeholder="Todas"
          class="w-full text-sm"
        ></p-dropdown>
      </div>
    </div>
  </div>

  <div class="flex-1 overflow-y-auto px-6 py-4 bg-gray-50">
    <div class="bg-white shadow rounded overflow-x-auto">
      <p-table
        [value]="comandas"
        [paginator]="false"
        [loading]="loading"
        styleClass="p-datatable-sm"
        [rowHover]="true"
        [stripedRows]="true"
        stripedRowsClass="bg-orange-50"
        responsiveLayout="scroll"
        class="min-w-full text-sm"
      >
        <ng-template pTemplate="header">
          <tr class="bg-gray-100">
            <th class="text-left px-6 py-3">Nº</th>
            <th class="text-left px-6 py-3">Status</th>
            <th class="text-left px-6 py-3">Mesas</th>
            <th class="text-left px-6 py-3">Garçom</th>
            <th class="text-right px-6 py-3">Subtotal</th>
            <th class="text-right px-6 py-3">Desconto</th>
            <th class="text-right px-6 py-3">Total</th>
            <th class="text-left px-6 py-3">Abertura</th>
            <th class="text-left px-6 py-3">Ações</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-comanda let-i="rowIndex">
          <tr [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-orange-50'">
            <td class="px-6 py-2 font-mono font-semibold">{{ comanda.number }}</td>
            <td class="px-6 py-2">
              <p-tag
                [value]="getStatusLabel(comanda.status)"
                [severity]="getStatusSeverity(comanda.status)"
                [rounded]="false"
              ></p-tag>
            </td>
            <td class="px-6 py-2">{{ getTablesDisplay(comanda.tables) }}</td>
            <td class="px-6 py-2">{{ comanda.employeeName || '—' }}</td>
            <td class="px-6 py-2 text-right">R$ {{ comanda.subtotal | number:'1.2-2' }}</td>
            <td class="px-6 py-2 text-right">R$ {{ comanda.discount | number:'1.2-2' }}</td>
            <td class="px-6 py-2 text-right font-semibold">R$ {{ comanda.total | number:'1.2-2' }}</td>
            <td class="px-6 py-2">{{ formatDate(comanda.openedAt) }}</td>
            <td class="px-6 py-2">
              <div class="flex flex-wrap gap-2 items-center">
                <p-button
                  pTooltip="Ver detalhes"
                  icon="pi pi-eye"
                  text
                  severity="secondary"
                  (click)="view(comanda)"
                ></p-button>
                <p-button
                  *ngIf="comanda.status === 'ABERTA'"
                  pTooltip="Fechar comanda"
                  icon="pi pi-lock"
                  text
                  severity="secondary"
                  (click)="fechar(comanda)"
                ></p-button>
                <p-button
                  *ngIf="comanda.status === 'ABERTA'"
                  pTooltip="Cancelar comanda"
                  icon="pi pi-times"
                  text
                  severity="danger"
                  (click)="cancelar(comanda)"
                ></p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="9" class="text-center py-8 text-gray-500">Nenhuma comanda encontrada</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="flex justify-center py-4">
      <p-paginator
        [first]="first"
        [rows]="rows"
        [totalRecords]="totalRecords"
        (onPageChange)="onPageChange($event)"
        [showCurrentPageReport]="true"
        [showPageLinks]="true"
        [showFirstLastIcon]="true"
        styleClass="custom-paginator"
      ></p-paginator>
    </div>
  </div>
</div>
